<template lang="html">
  <div class="timeline-comment">

   <div class="content" v-for="list in paymentUpdatedDates"
    v-if="dateLabel[list.label]" v-bind:key="list.label">
    <div class="content-item">
     <div class="dot dot-primary"></div>
    </div>
    <div class="content-body">
     <div class="content-body-status">
      <p class="content-item-title"
      v-if="dateLabel[list.label].name">
       {{dateLabel[list.label].name}}
      </p>
      <p class="content-item-primary"  v-if="!list.document">
        {{list.date | moment("DD MMM YYYY | hh:mmA")}}</small>
      </p>
      <p class="content-item-primary" v-if="list.document">
        {{list.document.updated_date | moment("DD MMM YYYY | hh:mmA")}}
      </p>
      <p class="content-item-primary" v-if="list.document">{{list.document.number}} </p>
      <p class="content-item-primary" v-if="list.document && list.document.document_type">
       <span>TYPE: </span> {{list.document.document_type}}
      </p>
      <p class="content-item-primary" v-if="list.document && list.document.comment">
        <span>Comment: </span> {{list.document.comment}}
      </p>
     </div>
    </div>
   </div>
   <div v-if="!paymentUpdatedDates.length">No document found</div>
  </div>
</template>

<script>
export default {
  name: 'Document',
  props: ['paymentUpdatedDates'],
  data() {
    return {
      currentRoute: '',
      dateLabel: {
        librarian_accepted: { name: 'VERIFIED', column: 'number' },
        processing: { name: 'POSTED', column: 'number' },
        on_hold: { name: 'PAYMENT HOLD', column: 'number' },
        payment_accepted: { name: 'PAID', column: 'clearance_number' },
      },
    };
  },
  computed: {
    taxAmount() {
      return this.$invoice.invoiceTax(this.invoice.order_payments, this.firstPayment);
    },
  },
};
</script>
